import { useFormikContext } from "formik";
import {
  DisplayFormErrors,
  DrawerFooterContent,
  InputField,
  SelectField,
  useCultures,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Row, Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

type DisplayChangeLevelLicenseFormProps = {
  //callback:(v:any)=> any
};
const AlertWrapper = styled.div`
  margin-top: 25px;
`;

export const DisplayChangeLevelLicenseForm: React.FC<
  DisplayChangeLevelLicenseFormProps
> = () => {
  const { t } = useTranslation();
  const { cultures } = useCultures();
  const { submitForm } = useFormikContext();

  return (
    <>
      <div>
        <Title level={4}>
          {t("licensemanager.changelevel.steps.checklicense")}
        </Title>
        <VerticalForm>
          <AlertWrapper>
            <DisplayFormErrors />
          </AlertWrapper>

          <InputField
            name="melco_customer_id"
            label={t("licensemanager.changelevel.form.melco_customer_id")}
          />
          <InputField
            name="serial_number"
            label={t("licensemanager.changelevel.form.serial_number")}
          />
          <SelectField
            name="language"
            label={t("licensemanager.changelevel.form.language")}
            options={cultures.map((culture) => {
              return {
                label: culture.name,
                value: culture.code,
              };
            })}
            showSearch
            optionFilterProp="label"
            info={t("licensemanager.create.form.languageinfo")}
          // onChange={(value: string, obj: DropDownValueLabelObj) => {
          //   callBackForLanguage(value, obj);
          // }}
          />

          <DrawerFooterContent>
            <Row justify="end">
              <Button
                style={{ minWidth: "80px" }}
                key="add-user-button"
                type="primary"
                onClick={() => {
                  //callback(createConfirmDetailsToDisplay);
                  submitForm();
                }}
              >
                {t("licensemanager.buttons.next")}
              </Button>
            </Row>
          </DrawerFooterContent>
        </VerticalForm>
      </div>
    </>
  );
};
